// Account settings page.
//
// Two affordances right now:
//   1. Download personal data (RGPD art. 15 / DSAR — Phase 9.4).
//   2. Pause and request deletion (Phase 9.6 — pause-and-manual-cleanup model).
//
// Both gate on a confirm dialog because both are user-impacting and
// irreversible-from-the-user's-perspective.

import { createRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useMe, usePauseAccount } from '../auth';
import { m } from '../paraglide/messages';
import { rootRoute } from './root';

export const accountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/account',
  component: AccountRoute,
});

function AccountRoute() {
  const me = useMe();
  const navigate = useNavigate();
  const pause = usePauseAccount();

  useEffect(() => {
    if (!me.isLoading && !me.data?.user) {
      navigate({ to: '/login', replace: true });
    }
  }, [me.isLoading, me.data, navigate]);

  if (me.isLoading || !me.data?.user) {
    return <p className="centered muted">{m.caseLoading()}</p>;
  }

  const onPause = () => {
    if (!window.confirm(m.accountDangerConfirm())) return;
    pause.mutate(undefined, {
      onSuccess: () => {
        // Drop them at /login with a success state in the address bar.
        window.location.assign('/login?paused=1');
      },
    });
  };

  const onExport = () => {
    // Server returns a JSON download with Content-Disposition. Plain
    // anchor click handles the browser-side save dialog.
    const a = document.createElement('a');
    a.href = '/api/me/export';
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <div className="card narrow">
      <h1>{m.accountHeading()}</h1>
      <p className="muted">
        {m.accountEmailLabel()}: <code>{me.data.user.email}</code>
      </p>

      <section style={{ marginTop: 24 }}>
        <h2 style={{ fontSize: '1.1rem' }}>{m.accountDataExportHeading()}</h2>
        <p className="muted small">{m.accountDataExportBody()}</p>
        <button type="button" onClick={onExport}>
          {m.accountDataExportButton()}
        </button>
      </section>

      <section style={{ marginTop: 32, paddingTop: 16, borderTop: '1px solid #e5e7eb' }}>
        <h2 style={{ fontSize: '1.1rem' }}>{m.accountDangerHeading()}</h2>
        <p className="muted small">{m.accountDangerBody()}</p>
        <button type="button" className="btn-warn" onClick={onPause} disabled={pause.isPending}>
          {pause.isPending ? m.navSigningOut() : m.accountDangerButton()}
        </button>
      </section>
    </div>
  );
}
